import { render, staticRenderFns } from "./ArchivedCampaignsComponent.vue?vue&type=template&id=514e75c1&scoped=true"
import script from "./ArchivedCampaignsComponent.vue?vue&type=script&lang=js"
export * from "./ArchivedCampaignsComponent.vue?vue&type=script&lang=js"
import style0 from "./ArchivedCampaignsComponent.vue?vue&type=style&index=0&id=514e75c1&prod&scoped=true&lang=scss"
import style1 from "./ArchivedCampaignsComponent.vue?vue&type=style&index=1&id=514e75c1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514e75c1",
  null
  
)

export default component.exports